import type { Router } from 'vue-router'

const RESUME_ROUTE_KEY = 'resumeRouteAfterReload'

function writeResumeRoute(fullPath: string) {
  try {
    sessionStorage.setItem(RESUME_ROUTE_KEY, fullPath)
  } catch (error) {
    console.warn('Could not remember route for reload', error)
  }
}

function readRouteToResumeAfterReload(): string | null {
  try {
    return sessionStorage.getItem(RESUME_ROUTE_KEY)
  } catch (error) {
    console.warn('Could not read route to resume after reload', error)
    return null
  }
}

function rememberRouteAcrossReload(router: Router) {
  router.afterEach((to, _from, failure) => {
    if (failure) return
    writeResumeRoute(to.fullPath)
  })
}

export function takeRouteToResumeAndRememberNext(router: Router): string | null {
  const routeToResume = readRouteToResumeAfterReload()
  rememberRouteAcrossReload(router)
  return routeToResume
}
